var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _circle2, _path14, _circle3, _circle4, _circle5, _path15, _circle6, _circle7, _path16, _circle8, _path17, _circle9, _circle10, _path18, _circle11, _path19, _circle12, _circle13, _path20, _circle14, _circle15, _circle16, _path21, _circle17, _circle18, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 186L106 174",
    stroke: "#FFD74E",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82 186L116 197",
    stroke: "#FFD74E",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82 186L36 136",
    stroke: "#FFD74E",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61 104L36 136",
    stroke: "#FFD74E",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156 107L203 88",
    stroke: "#FFD74E",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156 107L143 89",
    stroke: "#FFD74E",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152 56L143 89",
    stroke: "#FFD74E",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61 104L143 89",
    stroke: "#FFD74E",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91 80L61 104",
    stroke: "#FFD74E",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61 104L33 72",
    stroke: "#FFD74E",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M156 107L152 132",
    stroke: "#FFD74E",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M173 143L152 132",
    stroke: "#FFD74E",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7072 61.1028C29.6545 57.8671 34.3455 57.8671 36.2928 61.1028C37.132 62.4972 38.5008 63.4917 40.0863 63.8589C43.7653 64.711 45.2149 69.1724 42.7393 72.0243C41.6725 73.2533 41.1496 74.8624 41.2904 76.4838C41.6169 80.2461 37.8218 83.0034 34.3445 81.5302C32.846 80.8954 31.154 80.8954 29.6555 81.5302C26.1782 83.0034 22.3831 80.2461 22.7096 76.4838C22.8504 74.8624 22.3275 73.2533 21.2607 72.0243C18.7851 69.1724 20.2347 64.711 23.9137 63.8589C25.4992 63.4917 26.868 62.4972 27.7072 61.1028Z",
    fill: "#FFD74E",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.2913,
    cy: 68.9993,
    r: 0.642857,
    fill: "#262626",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.721,
    cy: 68.9993,
    r: 0.642857,
    fill: "#262626",
    stroke: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71.8574C30 71.8574 30.5455 73.0003 32 73.0003C33.4545 73.0003 34 71.8574 34 71.8574",
    stroke: "black",
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 106,
    r: 4,
    fill: "#FFBF00"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 104,
    r: 4,
    fill: "#FFBF00"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 198,
    r: 4,
    fill: "#FFBF00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M147.707 44.1028C149.654 40.8671 154.346 40.8671 156.293 44.1028C157.132 45.4972 158.501 46.4917 160.086 46.8589C163.765 47.711 165.215 52.1724 162.739 55.0243C161.672 56.2533 161.15 57.8624 161.29 59.4838C161.617 63.2461 157.822 66.0034 154.345 64.5302C152.846 63.8954 151.154 63.8954 149.655 64.5302C146.178 66.0034 142.383 63.2461 142.71 59.4838C142.85 57.8624 142.328 56.2533 141.261 55.0243C138.785 52.1724 140.235 47.711 143.914 46.8589C145.499 46.4917 146.868 45.4972 147.707 44.1028Z",
    fill: "#FFD74E",
    stroke: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.291,
    cy: 51.9993,
    r: 0.642857,
    fill: "#262626",
    stroke: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.721,
    cy: 51.9993,
    r: 0.642857,
    fill: "#262626",
    stroke: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M150 54.8574C150 54.8574 150.545 56.0003 152 56.0003C153.455 56.0003 154 54.8574 154 54.8574",
    stroke: "black",
    strokeLinecap: "round"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 203,
    cy: 88,
    r: 4,
    fill: "#FFBF00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7072 176.103C79.6545 172.867 84.3455 172.867 86.2928 176.103C87.132 177.497 88.5008 178.492 90.0863 178.859C93.7653 179.711 95.2149 184.172 92.7393 187.024C91.6725 188.253 91.1496 189.862 91.2904 191.484C91.6169 195.246 87.8218 198.003 84.3445 196.53C82.846 195.895 81.154 195.895 79.6555 196.53C76.1782 198.003 72.3831 195.246 72.7096 191.484C72.8504 189.862 72.3275 188.253 71.2607 187.024C68.7851 184.172 70.2347 179.711 73.9137 178.859C75.4992 178.492 76.868 177.497 77.7072 176.103Z",
    fill: "#FFD74E",
    stroke: "black"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.2913,
    cy: 183.999,
    r: 0.642857,
    fill: "#262626",
    stroke: "black"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.721,
    cy: 183.999,
    r: 0.642857,
    fill: "#262626",
    stroke: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M80 186.857C80 186.857 80.5455 188 82 188C83.4545 188 84 186.857 84 186.857",
    stroke: "black",
    strokeLinecap: "round"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 174,
    r: 4,
    fill: "#FFBF00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7072 126.103C32.6545 122.867 37.3455 122.867 39.2928 126.103C40.132 127.497 41.5008 128.492 43.0863 128.859C46.7653 129.711 48.2149 134.172 45.7393 137.024C44.6725 138.253 44.1496 139.862 44.2904 141.484C44.6169 145.246 40.8218 148.003 37.3445 146.53C35.846 145.895 34.154 145.895 32.6555 146.53C29.1782 148.003 25.3831 145.246 25.7096 141.484C25.8504 139.862 25.3275 138.253 24.2607 137.024C21.7851 134.172 23.2347 129.711 26.9137 128.859C28.4992 128.492 29.868 127.497 30.7072 126.103Z",
    fill: "#FFD74E",
    stroke: "black"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2913,
    cy: 133.999,
    r: 0.642857,
    fill: "#262626",
    stroke: "black"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.721,
    cy: 133.999,
    r: 0.642857,
    fill: "#262626",
    stroke: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33 136.857C33 136.857 33.5455 138 35 138C36.4545 138 37 136.857 37 136.857",
    stroke: "black",
    strokeLinecap: "round"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 80,
    r: 4,
    fill: "#FFBF00"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 143,
    cy: 89,
    r: 4,
    fill: "#FFBF00"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 142,
    r: 4,
    fill: "#FFBF00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M147.707 123.103C149.654 119.867 154.346 119.867 156.293 123.103C157.132 124.497 158.501 125.492 160.086 125.859C163.765 126.711 165.215 131.172 162.739 134.024C161.672 135.253 161.15 136.862 161.29 138.484C161.617 142.246 157.822 145.003 154.345 143.53C152.846 142.895 151.154 142.895 149.655 143.53C146.178 145.003 142.383 142.246 142.71 138.484C142.85 136.862 142.328 135.253 141.261 134.024C138.785 131.172 140.235 126.711 143.914 125.859C145.499 125.492 146.868 124.497 147.707 123.103Z",
    fill: "#FFD74E",
    stroke: "black"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.291,
    cy: 130.999,
    r: 0.642857,
    fill: "#262626",
    stroke: "black"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.721,
    cy: 130.999,
    r: 0.642857,
    fill: "#262626",
    stroke: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M150 133.857C150 133.857 150.545 135 152 135C153.455 135 154 133.857 154 133.857",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFull);
export default __webpack_public_path__ + "static/media/full.be38d1a79d37de0bab1fef0f74d63456.svg";
export { ForwardRef as ReactComponent };